import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { getSeccionesVisibles, esRutaActiva } from '../../config/menuSections';
import useVolverAtras from '../../hooks/useVolverAtras';

// Header compacto de 56px. Título y botón izquierdo se resuelven con una heurística barata
// que no exige registrar un título por ruta en cada una de las ~80 páginas existentes: si la
// ruta actual matchea un ítem de menuSections, es una pantalla "de primer nivel" (título =
// label del ítem, sin botón a la izquierda — el acceso al menú completo ya está en "Más" del
// bottom nav, tenerlo repetido acá era redundante); si no matchea (fichas de detalle tipo
// /tramites/:id, subpáginas como /clientes/inactivos que no están en el menú), se asume
// pantalla de detalle y el botón vuelve atrás con el mismo useVolverAtras() que ya usan las
// fichas de trámite. "Inicio" es caso especial: no está en menuSections pero es la pantalla
// raíz de la navegación, así que tampoco lleva botón de volver.
export default function MobileHeader({ totalNoLeidas, onAbrirCampana, campanaAbierta }) {
    const location = useLocation();
    const { user, puede } = useAuth();
    const volver = useVolverAtras();

    const esInicio = location.pathname === '/home' || location.pathname === '/';
    const seccionesVisibles = getSeccionesVisibles(user, puede);
    const itemActual = !esInicio
        ? seccionesVisibles
            .flatMap((section) => section.items || [])
            .find((item) => esRutaActiva(location.pathname, item.to))
        : null;

    const esPantallaPrincipal = esInicio || !!itemActual;
    const titulo = esInicio ? 'Inicio' : (itemActual ? itemActual.label : 'GestiónEJP');

    return (
        <header className="mob-header">
            {!esPantallaPrincipal && (
                <button
                    type="button"
                    className="mob-header-boton mob-tocable"
                    onClick={volver}
                    aria-label="Volver"
                >
                    <i className="bi bi-arrow-left" aria-hidden="true" />
                </button>
            )}

            <span className="mob-header-titulo">{titulo}</span>

            <div className="mob-header-acciones">
                <Link to="/busqueda" className="mob-header-boton mob-tocable" aria-label="Buscar">
                    <i className="bi bi-search" aria-hidden="true" />
                </Link>
                <button
                    type="button"
                    className="mob-header-boton mob-tocable mob-header-boton-campana"
                    onClick={onAbrirCampana}
                    aria-expanded={campanaAbierta}
                    aria-label={totalNoLeidas > 0 ? `Notificaciones, ${totalNoLeidas} sin leer` : 'Notificaciones'}
                >
                    <i className="bi bi-bell-fill" aria-hidden="true" />
                    {totalNoLeidas > 0 && (
                        <span className="mob-header-badge">{totalNoLeidas > 99 ? '99+' : totalNoLeidas}</span>
                    )}
                </button>
            </div>
        </header>
    );
}
